import { addUniqueItemByCode, assignIfExists, removeItemByCode } from '@/utils/resultsHelper';
import withDraft from '@/utils/draftHelper';
import actions from '@/collections/datasets/constants';
import { datasetCollection } from './state';
import findDatasetCollectionEntities from '../helper';

const addDatasetCollectionsList = withDraft((draft, { collection, items }) => {
  items.forEach(({ code }) => {
    const datasetCollectionList = findDatasetCollectionEntities(draft.datasetCollections, code);
    if (datasetCollectionList) {
      const datasetCollectionToAdd = datasetCollection();
      assignIfExists(datasetCollectionToAdd, collection);
      datasetCollectionList.results = addUniqueItemByCode(datasetCollectionList.results, datasetCollectionToAdd);
    }
  });
});

const removeDatasetCollectionsList = withDraft((draft, { collection, items }) => {
  items.forEach(({ code }) => {
    const datasetCollectionList = findDatasetCollectionEntities(draft.datasetCollections, code);
    if (datasetCollectionList) {
      datasetCollectionList.results = removeItemByCode(datasetCollectionList.results, collection);
    }
  });
});

export default {
  [actions.ADD_COLLECTION_DATASETS_SUCCESS]: addDatasetCollectionsList,
  [actions.REMOVE_COLLECTION_DATASETS_SUCCESS]: removeDatasetCollectionsList,
};
